import { CSMLImportSource } from './constants';

export const getImportSourceOptions = i18n => [
  {
    key: CSMLImportSource.Google,
    text: i18n.getString(_TL_('Google Ads')),
    title: i18n.getString(_TL_('Imported from Google Ads')),
  },
  {
    key: CSMLImportSource.Facebook,
    text: i18n.getString(_TL_('Meta Ads')),
    title: i18n.getString(_TL_('Imported from Meta Ads')),
  },
];
